import type { AssetsApprovalBySchema } from '@iconik-io/iconik-api/src/services/assets';

import type { SelectOption } from '../ui/select_field/types';

export type AssetApprovalStatus = NonNullable<AssetsApprovalBySchema['status']>;

export const REVIEW_STATUSES = {
  NO_STATUS: 'N/A',
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  REQUESTED: 'REQUESTED',
  MIXED: 'MIXED',
} as const;

// MIXED is a summary the UI shows over several assets, never one asset's own.
const ASSET_APPROVAL_STATUSES: ReadonlySet<string> = new Set(
  Object.values(REVIEW_STATUSES).filter(
    (status) => status !== REVIEW_STATUSES.MIXED,
  ),
);

export const isAssetApprovalStatus = (
  value: unknown,
): value is AssetApprovalStatus =>
  typeof value === 'string' && ASSET_APPROVAL_STATUSES.has(value);

export const reviewApprovedOptions: SelectOption[] = [
  { label: 'Approve', value: REVIEW_STATUSES.APPROVED },
  { label: 'Reject', value: REVIEW_STATUSES.NOT_APPROVED },
];

export const reviewRejectedOptions: SelectOption[] = [
  { label: 'Reject', value: REVIEW_STATUSES.NOT_APPROVED },
  { label: 'Approve', value: REVIEW_STATUSES.APPROVED },
];

export const reviewNAOptions: SelectOption[] = [
  { label: 'Approve', value: REVIEW_STATUSES.APPROVED },
  { label: 'Reject', value: REVIEW_STATUSES.NOT_APPROVED },
  { label: 'Request Approval', value: REVIEW_STATUSES.REQUESTED },
];

export const reviewRequestedOptions: SelectOption[] = [
  { label: 'Approve', value: REVIEW_STATUSES.APPROVED },
  { label: 'Reject', value: REVIEW_STATUSES.NOT_APPROVED },
  { label: 'Cancel Request', value: REVIEW_STATUSES.NO_STATUS },
];

export const reviewMixedOptions: SelectOption[] = [
  { label: 'Approve', value: REVIEW_STATUSES.APPROVED },
  { label: 'Reject', value: REVIEW_STATUSES.NOT_APPROVED },
];

// Used for search filters labels
export const searchReviewStatuses: SelectOption[] = [
  { label: 'Requested', value: REVIEW_STATUSES.REQUESTED },
  { label: 'Approved', value: REVIEW_STATUSES.APPROVED },
  { label: 'Rejected', value: REVIEW_STATUSES.NOT_APPROVED },
  { label: 'Mixed', value: REVIEW_STATUSES.MIXED },
];
